<template>
  <div class="page-content users-table-view" style="height: 100vh;">
    <div class="container-fluid bracket-custom-style">
      <Card class="header-card">
        <Row>
          <Col span="16">
          <span class="page-title">{{ $t('menu.clubs') }}</span>
          <Select class="" v-model="tableLenght" style="width: 70px" :placeholder="$t('global.kiezen')">
              <Option :value="10">10</Option>
              <Option :value="25">25</Option>
              <Option :value="50">50</Option>
              <Option :value="100">100</Option>
            </Select>
          </Col>
          <Col span="8" class="d-flex justify-content-end">
          <Button class="mr-2" type="warning" @click="modalAdd = true"><b>{{ $t('global.add') }}</b></Button>
          <ClubAddModal v-if="modalAdd" :club="selectedClub" @updateList="getList()"
            @close="() => { this.selectedClub = null; this.modalAdd = false }" />
          </Col>
        </Row>
      </Card>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Row v-else style="margin-top: 20px">
        <Col span="24">
        <div class="card">
          <div class="card-body-table"  style="overscroll-behavior: none;">
            <table id="users-table" class="table table-bordered dt-responsive table-striped nowrap">
              <thead class="positionThead">
                <tr>
                  <th></th>
                  <TableaHeadCol column="logo" :title="$t('club.logo')" />
                  <TableaHeadCol column="name" :title="$t('club.name')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="fullName" :title="$t('club.fullname')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="president" :title="$t('club.president')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="responsible" :title="$t('user.responsible')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="phone" :title="$t('user.table.phone')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="email" :title="$t('club.email')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="province" :title="$t('club.region')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="town" :title="$t('labels.city')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="idno" title="IDNO" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="sportsmenCount" :title="$t('club.athletes')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="licensesCount" :title="$t('menu.licenses')" :sortColumn="sortColumn" :sortByValue="sortByValue"
                    @sortBy="ColHead" />
                  <TableaHeadCol column="notes" :title="$t('driver.description')":sortColumn="sortColumn" 
                  :sortByValue="sortByValue"
                    @sortBy="ColHead" />

                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in arrayList.data">
                  <tr :key="item._id">
                    <td class="text-center">
                      <Button @click="() => { selectedClub = item; modalAdd = true; }" type="dashed"
                        class="user-info-btn"><b>Info</b></Button>
                    </td>
                    <td>
                      <Avatar :src="api_domain + item.logo" />
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.fullName }}</td>
                    <td>{{ item.president }}</td>
                    <td>{{ item.responsible }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.province }}</td>
                    <td>{{ item.town }}</td>
                    <td>{{ item.idno }}</td>
                    <td>{{ item.sportsmenCount }}</td>
                    <td>{{ item.licensesCount }}</td>
                    <td>{{ item.notes }}</td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
        </div>
        </Col>
      </Row>
      <Card>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span v-if="arrayFiltered.length">
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }} {{
                $t('global.of') }}
              {{ arrayFiltered.length }} {{ $t('global.entry') }} ({{ $t('global.filtered', { len: array.length }) }})
            </span>
            <span v-else>
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }} {{
                $t('global.of') }} {{ array.length }}
              {{ $t('global.entry') }}
            </span>
          </div>
          <Page @on-change="changePage" v-if="arrayList.total > 0" :current="arrayList.page"
            :page-size="parseInt(tableLenght)" :total="arrayList.total" />
        </div>
      </Card>
    </div>
  </div>
</template>
<script>
import ClubAddModal from './ClubAddModal.vue'
import mixin from '../mixinTable'
import TableaHeadCol from "../helper/table/TableaHeadCol.vue";
export default {
  components: {
    ClubAddModal,
    TableaHeadCol
  },
  mixins: [mixin],
  data() {
    return {
      modalAdd: false,
      selectedClub: null,
      loading: false,
      user: null
    }
  },
  watch:{
    async tableLenght(n, o) {
      await this.getList()
      localStorage.setItem('dt.length', n)
      // await this.getTempList()
    }
  },
  methods: {
    ColHead(val) {
      this.sortColumn = val;
      this.sortBy()
    },
    getCurrentUser() {
      const user = localStorage.getItem('user')
      this.user = JSON.parse(user)
    },
    async getList() {
      this.loading = true
      let response
      if (this.user.role.includes('manager')) { response = await this.$http.post('/club/list', { _id: this.user.clubId._id.toString() }) }
      else
        response = await this.$http.post('/club/list', {})
      let clubs = response.data
      this.array = clubs
      this.arrayList = this.paginator(this.array, 1, this.tableLenght)
      setTimeout(() => {this.loading = false}, 1000)
    }
  },
  async mounted() {
    this.tableLenght = +this.tableLenght;
    await this.getCurrentUser()
    await this.getList()
  }
}
</script>
<style scoped>

.bracket-custom-style .ivu-spin {
    background: #454751 !important;
    color: #ffffff;
}
.users-table-view :global(.ivu-avatar) {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.users-table-view .header-card {
  background: var(--bg-darkness);
  color: var(--text-color);
}

.users-table-view .page-title {
  font-size: 24px;
  font-weight: 600;
}

.users-table-view .table-striped tbody tr:nth-of-type(odd) {
    background-color: #e8e8e8;
}

.users-table-view :global(.ivu-select-selection .ivu-select-placeholder) {
  color: #495057;
}

.users-table-view .table tbody tr:hover,
.users-table-view .table-striped tbody tr:nth-of-type(odd):hover {
  background: #d3d3d3;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

#users-table {
  border-collapse: inherit;
  border-spacing: 0;
  width: inherit;
  contain: unset;
  table-layout: fixed;
  margin: 0 auto;
}

.users-table-view .card-body-table {
  overflow-x: scroll;
  height: calc(100vh - 275px);
  padding: 0;
}

.card-body-table .expire {
  background: #ff000047;
}

.card-body-table .todayBirthday {
  background: #8fbc8f75;
}

.card-body-table .tomorrowBirthday {
  background: #ffff0042;
}

#users-table :global(.ivu-tooltip-rel) {
  cursor: pointer;
}

#users-table tr th,
#users-table tr td {
  padding: 4px;
  font-size: 13px;
}

/*.sort-by {*/
/*  display: inline-block;*/
/*  float: right;*/
/*  cursor: pointer;*/
/*}*/

.user-info-btn {
  padding: 3px 10px;
}

#users-table td.user-style :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  vertical-align: middle;
}


#users-table td.user-style :global(.ivu-tooltip) {
  width: 205px;
}

#users-table td.user-iban-style :global(.ivu-tooltip) {
  width: 180px;
}

#users-table tr td,
#users-table tr th {
  vertical-align: middle;
  position: relative;
}

#users-table td.user-phone-list :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  max-height: 32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

#users-table td.user-phone-list :global(.ivu-tooltip) {
  width: 129px;
}

.badge-soft-primary {
  background-color: #dbe1f7 !important;
}

.good-rating {
  color: #18BE6B;
}

.average-rating {
  color: #FF9A01;
}

.black-list-rating {
  color: #EE4014;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before) {
  color: #18BE6B;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before),
.md-checkmark-style :global(.ivu-icon-md-checkmark-circle-outline:before) {
  line-height: 1;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/club/ClubList.vue